import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/businessstorepro/app/src/app/(default)/feasibility-studies/components/ReadyProjects.tsx");
